module.exports = __webpack_public_path__ + "img/katycorso.f0d8ed20.jpg";